export default "__VITE_ASSET__Y4pQe28E__"